import { render, staticRenderFns } from "./TaskMobileCard.vue?vue&type=template&id=70f17394&scoped=true&"
import script from "./TaskMobileCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TaskMobileCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TaskMobileCard.vue?vue&type=style&index=0&id=70f17394&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f17394",
  null
  
)

export default component.exports